import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { SubSection } from '@ui-framework/index';
import { Fragment } from 'react';

function CustomTabPanel(props) {
  const { children, value, index, inner = false, ...other } = props;

  const OuterContainer = inner ? SubSection : Fragment;

  return (
    <OuterContainer {...(inner && { sx: { mt: 2 } })}>
      <Grid2 role="tabpanel" hidden={value !== index} id={index} {...other}>
        {value === index && children}
      </Grid2>
    </OuterContainer>
  );
}

export default CustomTabPanel;
